<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="详情信息"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="20" :offset="2">
          <h3>订单信息</h3>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="订单号">{{detail.order_code}}</el-descriptions-item>
            <el-descriptions-item label="支付金额">{{detail.buy_price}}元</el-descriptions-item>
            <el-descriptions-item label="续费数量">{{detail.buy_num}}</el-descriptions-item>
            <el-descriptions-item label="续费时长">{{detail.buy_duration}}天</el-descriptions-item>
            <el-descriptions-item label="支付企业">{{detail.organize_name}}</el-descriptions-item>
            <el-descriptions-item label="支付人">{{detail.admin_name}}</el-descriptions-item>
            <el-descriptions-item label="支付人手机">{{detail.admin_mobile}}</el-descriptions-item>
            <el-descriptions-item label="支付类型">{{detail.type_name}}</el-descriptions-item>
            <el-descriptions-item label="支付状态">
              <el-tag v-if="detail.status === 1">{{detail.status_desc}}</el-tag>
              <el-tag v-if="detail.status === 2" type="success">{{detail.status_desc}}</el-tag>
              <el-tag v-if="detail.status === 3" type="info">{{detail.status_desc}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="操作时间">{{detail.update_at}}</el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col :span="20" :offset="2">
          <h3>充值商品信息</h3>
          <el-table :data="detail.goods_list" border style="width: 100%">
            <el-table-column prop="name" label="卡号"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: '',
      },
      detail: {},
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {},
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.detail = {}
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminRechargeDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.detail = {}
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>